import CryptoJS from 'crypto-js'
import { CONFIG } from '../../Config/config'

const encrypt = key => {
  return CryptoJS.AES.encrypt(key, CONFIG.CRYPTO_SECRET_KEY).toString()
}

const decrypt = key => {
  return CryptoJS.AES.decrypt(key, CONFIG.CRYPTO_SECRET_KEY).toString(
    CryptoJS.enc.Utf8,
  )
}

export { encrypt, decrypt }
